let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("b6SmL")).then(() => parcelRequire('3D5ta'));